import React from 'react';
import { CheckBox } from '@lmt/unicorn-shared/app/components/common/ui-kit/CheckBox';
import styles from './UIEditorBlocks.module.scss';

export const CheckboxSettings: React.FC<{
  label: string;
  isChecked: boolean;
  disabled?: boolean | undefined;
  setValue: (newValue: boolean) => void;
}> = (props) => {
  return (
    <CheckBox
      name={props.label}
      title={props.label}
      checked={props.isChecked}
      onChange={(e) => props.setValue(e.target.checked)}
      className={styles.groupItemCheckbox}
      disabled={props.disabled}
    />
  );
};
